/*
  Text input for a GroupAccount
  is responsible for:
    Creating and maintaining the input DOM element
    Insuring the input is a valid email
*/

class AccountInput {

  constructor(props) {
    this.props = props;
  }

  domElement() {
    if( !this._domElement ) {
      this._domElement = this.createDomElement();
    }
    return this._domElement;
  }

  createDomElement() {
    const tmp = document.createElement('div');
    tmp.innerHTML = `
      <div class="Input Input--smallInline">
        <input class="Input-input" type="email" value="${this.props.initialValue}" placeholder="Enter Email Address">
        <p class="Input-error"></p>
      </div>
    `;
    const domElement = tmp.firstElementChild;
    this.input = domElement.querySelector('input');
    this.input.addEventListener('keyup', e=>this.onKeyUp(e) );
    this.input.addEventListener('blur', e=>this.onBlur(e) );
    this.elError = domElement.querySelector('.Input-error');
    return domElement;
  }

  onKeyUp(e) {
    if(this.hasError ) {
      this.hideError();
      this.hasError = false;
    }
    if( e.keyCode === 13 ) {
      this.setValue();
    }
  }

  onBlur(e) {
    this.setValue();
  }

  setValue() {
    if( !this.deleting && this.validate() ) {
      this.deleting = true;
      this.props.finishedEditingCallback(this.input.value);
    }
  }

  validate() {
    if( this.input.value == '' ){
      return true;
    }

    if( this.input.checkValidity() == false ) {
      this.showError('Invalid Email')
      return false;
    }

    if( this.props.isEmailUniqueCallback(this.input.value) == false ) {
      this.showError('Email already added')
      return false;
    }

    return true;
  }

  showError(error) {
    this.hasError = true;
    this.elError.innerText = error;
    this._domElement.classList.add('Input--hasErrors');
  }

  hideError() {
    this._domElement.classList.remove('Input--hasErrors');
  }
}
